import { useParams, matchPath, useLocation } from "react-router-dom";
import {
  USER_SERVICE_CHARGES_INVOICES_PATH,
  USER_SERVICE_CHARGES_PATH,
  USER_SERVICE_CHARGES_PAYMENTS_PATH,
  USER_PATH,
} from "../../../../paths";
import { BreadcrumbItem } from "../../../../shared/breadcrumbs/BreadcrumbContext";
import { partition } from "lodash";
import { useUserDetails } from "../../../../api/hooks/useUserDetails";
import { useUsers } from "../../../../api/hooks/useUsers";

export const useUserLinks = () => {
  const { id } = useParams();
  const { pathname } = useLocation();

  const { users } = useUsers();
  const { user, isPending } = useUserDetails({ id });

  const links: BreadcrumbItem[] = [];

  if (id && user) {
    if (users && users.length > 1) {
      links.push({
        label: user.public_name || user.email,
        path: USER_PATH,
        params: {
          id,
        },
        menu: false,
      });
    }

    links.push(
      {
        label: "Service Charges",
        path: USER_SERVICE_CHARGES_PATH,
        params: {
          id,
        },
      },
      {
        label: "Payments",
        menuLabel: "Payments",
        menu: true,
        path: USER_SERVICE_CHARGES_PAYMENTS_PATH,
        params: {
          id,
        },
      },
      {
        label: "Details",
        menuLabel: "Details",
        menu: true,
        path: USER_SERVICE_CHARGES_INVOICES_PATH,
        params: {
          id,
        },
      },
    );
  }

  const [matchedLinks, unmatchedLinks] = partition(links, (link) =>
    "to" in link
      ? matchPath({ path: link.to, end: false }, pathname)
      : matchPath({ path: link.path, end: false }, pathname),
  );

  return {
    id,
    user,
    isPending,
    links,
    matchedLinks,
    unmatchedLinks,
    menuLinks: links
      .filter(({ menu }) => menu)
      .map(({ menuLabel, ...rest }) => ({ ...rest, label: menuLabel || rest.label })),
  };
};
